export const LISTS_OP_TYPE = {
  CREATE: 'Create',
  UPDATE: 'Update',
  DELETE: 'Delete',
};
